import React from 'react';
import DynamicSiteForm from './DynamicSiteForm';

const GetConnectedForm = ({ onClose }) => (
  <DynamicSiteForm formKey="get-connected" onClose={onClose} maxWidth="700px" />
);

export default GetConnectedForm;
